// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__24Zlz","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3sDuE","obliqueLine":"membershipbadge_obliqueLine__3EgUx"};